import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import {style} from '../../components/pdf/fontstyles';
import {AutoText} from '../../components/pdf/autoText'; 



const styles = StyleSheet.create({
    

          bulletRow: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 6, 
          },
          bulletSymbol: {
            width: 10,
            fontSize: 10,
            marginRight: 5, 
          },
          bulletText: {
            flex: 1,
            fontSize: 10,
            textAlign: 'justify',
            lineHeight: 1.5,
          },
          fingerprintTable: {
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
            marginBottom: 10,
          },
          fingerprintRow: {
            flexDirection: 'row',
            borderBottomWidth: 1,
            borderBottomColor: '#000',
          },
          fingerprintHeader: {
            fontWeight: 'bold',
            padding: 5,
            textAlign: 'center',
          },
          fingerCol: {
            width: '20%',
            borderRightWidth: 1,
            borderRightColor: '#000',
          },
          fingerSpace: {
            height: 70, // Adjust this value for more/less space
            backgroundColor: '#fff', // White background for fingerprint area
          },

        });


        
        
const PensionThumb = ({ result }) => {

      
  
  return (
              <View size="A4" style={style.page}> 
              
              <Text style={[style.subtitle, {textAlign: 'left'}]}>Enclosures of form No.5.</Text>


                <Text style={[style.title, style.ArialBold]}>THE THUMB & FINGER IMPRESSION CARD</Text>


                    {/* Fingerprint Table */}
                <View style={styles.fingerprintTable}>
                {/* Header Row */}
                <View style={styles.fingerprintRow}>
                    <Text style={[styles.fingerprintHeader, styles.fingerCol]}>Little Finger</Text>
                    <Text style={[styles.fingerprintHeader, styles.fingerCol]}>Ring Finger</Text>
                    <Text style={[styles.fingerprintHeader, styles.fingerCol]}>Middle Finger</Text>
                    <Text style={[styles.fingerprintHeader, styles.fingerCol]}>Fore Finger</Text>
                    <Text style={[styles.fingerprintHeader, styles.fingerCol]}>Thumb</Text>
                </View>

                {/* Space Row - Big empty space for fingerprints */}
                <View style={[styles.fingerprintRow, { height: 70 }]}>
                    <View style={[styles.fingerCol, styles.fingerSpace]}></View>
                    <View style={[styles.fingerCol, styles.fingerSpace]}></View>
                    <View style={[styles.fingerCol, styles.fingerSpace]}></View>
                    <View style={[styles.fingerCol, styles.fingerSpace]}></View>
                    <View style={[styles.fingerCol, styles.fingerSpace]}></View>
                </View>
                </View>

                <AutoText style={[style.paragraph, { marginTop: 10 }]}>Certified that the thumb & Finger impressions are those of the left hand of {result.employeeName}</AutoText>

                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>

                <View style={[style.solidLine, {marginTop: 30}]} />

                <Text style={[style.subtitle, {textAlign: 'left'}]}>Enclosures of form No.5. (item 5)</Text>


                <Text style={[style.title, style.ArialBold]}>Identification Marks</Text>

                <Text style={[style.paragraph, { marginTop: 10 }]}>1.	Height: {result.Height} </Text>
                <AutoText style={[style.paragraph, { marginTop: 10 }]}>2.	Personal Marks(if any):	{result.splMark} </AutoText>

                <AutoText style={[style.paragraph, { marginTop: 10 }]}>Certified that the above identification Marks are those of  {result.employeeName}  </AutoText>

                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>
              </View>

);
};

export default PensionThumb;